













































































































































import Vue from 'vue';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { User } from '@/api/user/User';
import { Fi } from '@/api/fi/Fi';

import { mapState } from 'vuex';
import { DailyLoadFilter } from '@/api/dashboard/DailyLoadFilter';
import UserSelector from '@/components/userselector.vue';
import FIMultiSelector from '@/components/fimultiselector.vue';
import DailyLoadFileStatusPicker from '@/components/dailyload/dailyloadfilestatuspicker.vue';
import DailyLoadProcessStatusPicker from '@/components/dailyload/dailyloadprocessstatuspicker.vue';
import TextBoxDatePicker from '@/components/textboxdatepicker.vue';
import LocalDateTime from '@/types/localdatetime';
import LocalDateTimeUtils from '@/util/localdatetimeutils';

@Component({
  components: {
    UserSelector,
    FIMultiSelector,
    DailyLoadFileStatusPicker,
    DailyLoadProcessStatusPicker,
    TextBoxDatePicker,
  },
  computed: {
    ...mapState(['auth']),
  },
})
export default class DailyLoadSearchFilterForm extends Vue {
  @Prop() preloadedFilter!: DailyLoadFilter;

  @Prop({ default: false }) loading!: boolean;

  @Prop({ default: () => [] }) allUsers!: User[];

  @Prop({ default: false }) isYesterdayFederalHoliday!: boolean;

  workingFilter: DailyLoadFilter = DailyLoadSearchFilterForm.createEmptyFilter();

  selectedUsers: User[] = [];

  selectedFis: Fi[]| null = [];

  allFis: Fi[] = [];

  rangeStartDate: string = LocalDateTimeUtils.computeOffsetDaysString(
    DailyLoadSearchFilterForm.computeStartingDayOffset(this.isYesterdayFederalHoliday),
  );

  rangeEndDate: string = LocalDateTimeUtils.computeOffsetDaysString(0);

  valid: boolean = true;

  auth!: AuthStore;

  mounted() {
    this.getFis();
    this.onPreloadedFiltersChanged();
    this.initProcessingDateRange();
  }

  initProcessingDateRange() {
    if (!this.workingFilter.processingStartDate) {
      const startingDateOffset: number = DailyLoadSearchFilterForm.computeStartingDayOffset(
        this.isYesterdayFederalHoliday,
      );
      this.rangeStartDate = this.dateStringOffsetDaysFromToday(startingDateOffset);
      this.workingFilter.processingStartDate = LocalDateTimeUtils.toDateArray(this.rangeStartDate);
    } else {
      this.rangeStartDate = LocalDateTimeUtils.toDateString(this.workingFilter.processingStartDate)!;
    }

    if (!this.workingFilter.processingEndDate) {
      this.rangeEndDate = this.dateStringOffsetDaysFromToday(0);
      this.workingFilter.processingEndDate = LocalDateTimeUtils.toDateArray(this.rangeEndDate);
    } else {
      this.rangeEndDate = LocalDateTimeUtils.toDateString(this.workingFilter.processingEndDate)!;
    }
  }

	@Watch('auth', { deep: true })
  getFis() {
	  if (this.auth && this.auth.headerData) {
	    this.allFis = this.auth.headerData.fis;
	  }
  }

	dateEndRangeRules() {
	  return this.dateRangeRules('End Date cannot be before Start Date');
	}

	dateStartRangeRules() {
	  return this.dateRangeRules('Start Date cannot be after End Date');
	}

	dateRangeRules(message:String) {
	  const rangeStartDate = new LocalDateTime(this.rangeStartDate);
	  const rangeEndDate = new LocalDateTime(this.rangeEndDate);
	  if (rangeEndDate.toDate().getTime() < rangeStartDate.toDate().getTime()) {
	    return message;
	  }

	  return true;
	}

	validateForm() {
	  (this.$refs.form as any).validate();
	}

  @Watch('preloadedFilter', { deep: true })
	onPreloadedFiltersChanged() {
	  if (this.preloadedFilter) {
	    this.workingFilter = DailyLoadSearchFilterForm.deepCopy(this.preloadedFilter);
	    this.resetSelectedFis();
	    this.resetSelectedUser();
	  }

	  this.initProcessingDateRange();
	}

  @Watch('selectedUsers')
  onSelectedUserUpdated() {
    const selectedUserIds : number[] = [];
    let foundUnassignedUser = false;
    for (let i = 0; i < this.selectedUsers.length; i++) {
      if (this.selectedUsers[i].id === null) {
        foundUnassignedUser = true;
      } else {
        selectedUserIds.push(this.selectedUsers[i].id as number);
      }
    }

    this.workingFilter.userIds = selectedUserIds;
    this.workingFilter.unassignedUser = foundUnassignedUser;
  }

  @Watch('selectedFis')
  onSelectedFisUpdated() {
    if (!this.selectedFis) {
      this.workingFilter.fiIds = [];
    } else {
      const fiIds: number[] = [];
      this.selectedFis.forEach((item) => {
        if (item && item.fiId) {
          const fiId = DailyLoadSearchFilterForm.toNumber(item.fiId);
          if (fiId) {
            fiIds.push(fiId);
          }
        }
      });

      this.workingFilter.fiIds = fiIds;
    }
  }

  onNewStartDate(startDate: string) {
    this.workingFilter.processingStartDate = LocalDateTimeUtils.toDateArray(startDate);
    this.rangeStartDate = startDate;
    this.validateForm();
  }

  onNewEndDate(endDate: string) {
    this.workingFilter.processingEndDate = LocalDateTimeUtils.toDateArray(endDate);
    this.rangeEndDate = endDate;
    this.validateForm();
  }

  dateStringOffsetDaysFromToday = (offset: number) => LocalDateTimeUtils.computeOffsetDaysString(offset)

  saveFilter() {
    this.$emit('filterSave', this.workingFilter);
  }

  applyFilter() {
    this.$emit('filterApply', this.workingFilter);
  }

  resetSelectedFis() {
    const selectedFis = [];
    for (let i = 0; i < this.workingFilter.fiIds.length; i++) {
      const fiId = this.workingFilter.fiIds[i];
      const fi: Fi | null = this.findFiById(fiId);
      if (fi) {
        selectedFis.push(fi);
      }
    }
    this.selectedFis = selectedFis;
  }

  resetSelectedUser() {
    const selectedUsers : User[] = [];
    if (this.workingFilter.unassignedUser) {
      selectedUsers.push((this.$refs.userSelector as UserSelector).unassignedUser());
    }

    const foundUser : User | null = null;
    for (let i = 0; i < this.workingFilter.userIds.length; i++) {
      const userId = this.workingFilter.userIds[i];
      const user = this.findUserById(userId);
      if (user) {
        selectedUsers.push(user);
      }
    }
    this.selectedUsers = selectedUsers;
  }

  resetFilter() {
    this.workingFilter = DailyLoadSearchFilterForm.createEmptyFilter();
    this.selectedUsers = [];
    this.selectedFis = [];
    this.initProcessingDateRange();
    this.validateForm();
    this.applyFilter();
  }

  findFiById(fiId: number | undefined) : Fi | null {
    for (let i = 0; i < this.allFis.length; i++) {
      const fi = this.allFis[i];
      if (fiId === DailyLoadSearchFilterForm.toNumber(fi.fiId)) {
        return fi;
      }
    }
    return null;
  }

  findUserById(userId: number) : User | null {
    for (let i = 0; i < this.allUsers.length; i++) {
      const user = this.allUsers[i];
      if (userId === DailyLoadSearchFilterForm.toNumber(user.id)) {
        return user;
      }
    }
    return null;
  }

  showError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  static computeStartingDayOffset(wasYesterdayFederalHoliday: boolean) : number {
    let startingOffset = -1;
    if (wasYesterdayFederalHoliday) {
      startingOffset--;
    }
    while (DailyLoadSearchFilterForm.isOffsetOnWeekend(startingOffset)) {
      startingOffset--;
    }

    return startingOffset;
  }

  static isOffsetOnWeekend(offset: number) {
    const offsetDay : Date = new Date();
    offsetDay.setDate(offsetDay.getDate() + offset);
    // Saturday is day value Six and Sunday is day value Zero
    return offsetDay.getDay() % 6 === 0;
  }

  static createEmptyFilter() : DailyLoadFilter {
    return {
      userIds: [],
      fiIds: [],
      unassignedUser: false,
      dropDateOnly: false,
      processingStartDate: null,
      processingEndDate: null,
      transformationStatuses: [],
      fidilStatuses: [],
      krpStatuses: [],
      loadStatuses: [],
    };
  }

  static deepCopy(filter: DailyLoadFilter) {
    const theCopy = { ...filter };
    if (filter.fiIds) {
      theCopy.fiIds = [...filter.fiIds];
    }
    if (filter.loadStatuses) {
      theCopy.loadStatuses = [...filter.loadStatuses];
    }
    if (filter.krpStatuses) {
      theCopy.krpStatuses = [...filter.krpStatuses];
    }
    if (filter.transformationStatuses) {
      theCopy.transformationStatuses = [...filter.transformationStatuses];
    }
    if (filter.fidilStatuses) {
      theCopy.fidilStatuses = [...filter.fidilStatuses];
    }
    return theCopy;
  }

  static toNumber(value: number | string | null) : number | null {
    if (!value) {
      return null;
    }

    return typeof value === 'number' ? value : parseInt(value, 10);
  }
}
